'use client';

import { useEffect } from 'react';
import RichText from '@/components/ui/RichText/RichText';

interface AppErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function AppError({ error, reset }: AppErrorProps) {
  useEffect(() => {
    console.error('Route error boundary caught an error:', error);
  }, [error]);

  return (
    <div className="mx-auto flex min-h-[60vh] max-w-lg flex-col items-center justify-center px-6 py-16 text-center">
      <div className="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-red-50">
        <svg
          width="36"
          height="36"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="text-red-500"
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
      </div>

      <RichText
        styles={{
          p: ' text-2xl font-bold text-theme-primary',
        }}
      >
        {'Something went wrong'}
      </RichText>

      <RichText
        styles={{
          p: 'mt-3  text-text-secondary',
        }}
      >
        {'We could not load this page right now. Please try again.'}
      </RichText>

      <button
        type="button"
        onClick={reset}
        className="bg-primary hover:bg-primary-hover focus-visible:ring-primary mt-8 inline-flex items-center rounded-lg px-6 py-3 text-sm font-semibold text-white transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
      >
        Try again
      </button>
    </div>
  );
}
